import React, { useContext } from 'react';

import LedgerContext from '../../contexts/LedgerContext';
import Table from '../../../Table/Table';
import EmptyState from '../../../EmptyState/EmptyState';
import getTableBodyContent from '../../helpers/table/getTableBodyContent';
import getTableHeaders from '../../helpers/table/getTableHeaders';

const TableData = ({
  id,
  shimmer,
  columns,
  sort,
  bulkActions,
  emptyState,
  ordering,
  rowActions,
  bulkActionsProps,
  onClickRow,
  ribbon,
  twiddle,
  twiddleRowAttrs,
  ...otherProps
}) => {
  const { selected, data, visibleColumns } = useContext(LedgerContext);

  const renderTable = () => {
    const headers = getTableHeaders(columns, {
      visibleColumns,
      ordering,
      withRowActions: !!rowActions,
    });
    return (
      <Table
        {...otherProps}
        id={`ledger-table-${id}`}
        headers={headers}
        data={data}
        renderRow={(data, index) =>
          getTableBodyContent(data, {
            index,
            visibleColumns,
            shimmer,
            columns,
            rowActions,
            onClickRow,
            ribbon,
            twiddle,
            twiddleRowAttrs,
          })
        }
        selected={selected}
        sort={sort}
        {...bulkActionsProps(bulkActions)}
      />
    );
  };

  if (shimmer && shimmer.loading) {
    // Shimmer loading case. The table knows how to display itself without content when it's loading.
    return renderTable();
  }
  if (data === null) {
    // When data is null, it means that in the first request - WITHOUT filters - we don't have data.
    return (
      <EmptyState
        data-testid={`ledger-empty-state-${id}`}
        type={emptyState.type}
        text={emptyState.text}
        icon={emptyState?.icon}
      >
        {emptyState.children}
      </EmptyState>
    );
  }
  if (data.length === 0) {
    // When data is [], it means that we don't have data BECAUSE of the filters.
    return (
      <EmptyState
        data-testid={`ledger-empty-state-${id}`}
        type={emptyState.type}
        text="No matching results found."
        icon={emptyState?.icon}
      />
    );
  }
  return renderTable();
};

export default TableData;
